<template>
  <div v-if="resultadoBusqueda"> <!--<pre>{{ datos }}</pre>--->
    <div v-if="resultadoBusqueda.length>0 || textInput!==''" class="d-flex justify-content-between">
      <h5>{{ titulo }}</h5>
      <input v-if="search" type="text" class="form-control form-control-sm" style="width:20%;" placeholder="Buscar" v-model.trim="textInput">
    </div>
    <table class="styled-table">
      <tbody>
        <tr>
          <td>

            <ul>
              <li  v-for="(contenido, index) in resultadoBusqueda" :key="index">
                <div class="contenido-fila">
                  <!-- Mostrar título -->
                  <span class="contenido-titulo">{{ contenido.titulo || 'Descargar documento' }} <small class="text-muted">{{ contenido.pieTitulo }}</small> </span>

                  <!-- Contenedor para los íconos -->
                  <div class="iconos-contenedor">
                    <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                      <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                    </a>
                    <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                      <i class="fas fa-file-word icono-archivo icon-word"></i>
                    </a>
                    <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                      <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                    </a>
                    <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                      <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                    </a>
                    <a v-if="contenido.link" :href="contenido.link" target="_blank">
                      <i class="fas fa-link icono-archivo icon-url"></i>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>
<script>

import('@/assets/css/tablaTypeFiles.css');
export default {
    name: 'tablaSimple',
    data() {
        return {
          data: [],
          resultadoBusqueda: [],
          textInput: ''
        };
    },
    props:{
      datos: null,
      titulo: '',
      search: {
        type: Boolean,
        default: true
      }
    },
    async created() {},
    async mounted(){
     if(this.datos){
        setTimeout(() => {
          if(this.datos.seccion.length>0){
            this.resultadoBusqueda =  this.datos.seccion
          }
      }, 1500);
     }
    },
    methods: {
      filtrado(){
            // obtengo texto del input, es necesario limpiar cada vez q filtre para q no dupliq resultados
            let texto = this.textInput.toLowerCase();
            this.resultadoBusqueda = [];

            // for(comparo el nombre del tramite con el texto del input)
            for(let item of this.datos.seccion){
                let titulo = item.titulo.toLowerCase();

                // si hay resultados, armo objeto y lo guardo en el array de resultados
                if(titulo.indexOf(texto) !== -1){
                    let obj = item;
                    this.resultadoBusqueda.push(obj);
                }
            }
        }
    },
    watch:{
      textInput: function(){
           if(this.textInput == '')  this.resultadoBusqueda = this.datos.seccion
           else this.filtrado();
       },
       datos(){
        this.resultadoBusqueda = this.datos.seccion;
       }
    }
}
</script>
